<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-10 21:19:08
 * @LastEditTime: 2020-09-27 09:59:18
 * @Description: 添加编辑储罐借用抽屉
-->
<template>
  <Drawer width="400" :title="`更换销售项目`" v-model="drawerOpened">
    <Form
      @submit.native.prevent
      ref="formItem"
      :model="formItem"
      label-position="top"
    >
      <div class="wrap">
        <div class="sales-wrap">
          <div>
            将物料编码：{{ JDItemCode }}，名称：{{ name }}，关联到销售项目：
          </div>
          <FormItem prop="sales-wrap">
            <Input
              v-model="searchText"
              search
              placeholder="搜索销售项目..."
              @on-change="getSalesListMethod"
              clearable
            ></Input>
          </FormItem>
          <div class="table-wrapper" ref="tableWrapper">
            <Table :columns="columns" :data="salesList" :height="tableHeight">
              <template
                slot-scope="{ row }"
                slot="link"
                style="padding-left: 0"
              >
                <Button
                  type="primary"
                  ghost
                  size="small"
                  @click="linkSales(row)"
                  >关联</Button
                >
              </template></Table
            >
          </div>
        </div>
      </div>
    </Form>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ReplaceSalesDrawer",
  data() {
    return {
      salesLoading: false,
      drawerOpened: false,
      openedTankRental: null,
      tableHeight: 300,
      searchText: "",
      formItem: {
        fromSales: null,
      },
      columns: [
        {
          title: "销售项目简称",
          key: "weight",
          align: "center",
          width: 260,
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },
              },
              params.row.JDName ? params.row.JDName : params.row.abbr
            );
          },
        },
        {
          title: " ",
          key: "link",
          slot: "link",
          align: "left",
        },
      ],
      selectedSales: [],
      salesList: [],
      openedSales: null,
      name: null,
      JDItemCode: null,
      sales: null,
    };
  },
  computed: {
    ...mapState({}),
  },
  methods: {
    async getSalesListMethod() {
      if (this.searchText !== "") {
        this.salesLoading = true;
        const data = await this.getSales({ cus_name: this.searchText });
        this.salesList = data.salesList.filter(
          (item) => item._id !== this.openedSales._id
        );
        this.salesLoading = false;
      }
    },
    ...mapActions({
      getSales: "sales/getSalesAction",
      bindSalesWithItemCodeSales: "sales/bindSalesWithItemCodeSalesAction",
    }),
    async openDrawer(openedSales) {
      this.drawerOpened = true;
      this.openedSales = null;
      if (openedSales) {
        this.name = openedSales.abbr
          ? openedSales.abbr
          : openedSales.customer.name + "-" + openedSales.material.model;
        this.JDItemCode = openedSales.JDItemCode;
        this.formItem.fromSales = openedSales._id;
      }
      this.openedSales = openedSales;
    },
    async linkSales(sales) {
      this.formItem.sales = sales._id;
      try {
        await this.bindSalesWithItemCodeSales(this.formItem);
        this.$Message.success("关联成功");
        this.formItem.sales = null;
      } catch (error) {
        this.$Message.error("关联失败");
        this.formItem.sales = null;
      }
    },
  },
  mounted() {
    this.getSalesListMethod({});
  },
};
</script>

<style scoped lang="stylus">
.wrap
  display flex
  padding 10px 10px 0 20px

.sales-wrap
  width 360px
</style>
